import * as React from "react";

export const DialogBackdropContext = React.createContext<string | undefined>(
  undefined,
);
